module.exports = __webpack_public_path__ + "img/12.4b7ca4a4.png";